// extracted by mini-css-extract-plugin
export default {"alert":"deleteSakAlert_alert__iQb9U","actionButtons":"deleteSakAlert_actionButtons__Nu+GH"};